import React, { useState } from 'react';
import { PlusIcon, SearchIcon, FilterIcon, DownloadIcon, UploadIcon, EditIcon, TrashIcon, MoreHorizontalIcon, UsersIcon, CheckCircleIcon, XCircleIcon, MailIcon } from 'lucide-react';
const Recipients = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('all');
  const recipients = [{
    id: '1',
    name: 'Aarav Sharma',
    email: 'aarav.sharma@example.com',
    status: 'subscribed',
    group: 'Active Users',
    joinedDate: 'Jan 15, 2023',
    lastActivity: 'May 20, 2023',
    emailsSent: 24,
    emailsOpened: 18
  }, {
    id: '2',
    name: 'Priya Patel',
    email: 'priya.patel@example.com',
    status: 'subscribed',
    group: 'Premium Members',
    joinedDate: 'Feb 10, 2023',
    lastActivity: 'May 22, 2023',
    emailsSent: 20,
    emailsOpened: 19
  }, {
    id: '3',
    name: 'Rahul Verma',
    email: 'rahul.verma@example.com',
    status: 'unsubscribed',
    group: 'Inactive Users',
    joinedDate: 'Dec 5, 2022',
    lastActivity: 'Mar 10, 2023',
    emailsSent: 15,
    emailsOpened: 5
  }, {
    id: '4',
    name: 'Ananya Singh',
    email: 'ananya.singh@example.com',
    status: 'subscribed',
    group: 'New Sign-ups',
    joinedDate: 'May 18, 2023',
    lastActivity: 'May 22, 2023',
    emailsSent: 3,
    emailsOpened: 3
  }, {
    id: '5',
    name: 'Vikram Reddy',
    email: 'vikram.reddy@example.com',
    status: 'bounced',
    group: 'Active Users',
    joinedDate: 'Mar 20, 2023',
    lastActivity: 'Apr 15, 2023',
    emailsSent: 12,
    emailsOpened: 8
  }];
  const groups = [{
    id: 'all',
    name: 'All Recipients',
    count: 3852
  }, {
    id: 'active',
    name: 'Active Users',
    count: 2341
  }, {
    id: 'premium',
    name: 'Premium Members',
    count: 892
  }, {
    id: 'new',
    name: 'New Sign-ups',
    count: 156
  }, {
    id: 'inactive',
    name: 'Inactive Users',
    count: 423
  }];
  const filteredRecipients = recipients.filter(recipient => {
    const matchesSearch = recipient.name.toLowerCase().includes(searchQuery.toLowerCase()) || recipient.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || recipient.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const getStatusBadge = (status: string) => {
    const statusConfig = {
      subscribed: {
        bg: 'bg-green-100',
        text: 'text-green-800',
        icon: <CheckCircleIcon size={12} data-id="element-374" />,
        label: 'Subscribed'
      },
      unsubscribed: {
        bg: 'bg-secondary-100',
        text: 'text-secondary-800',
        icon: <XCircleIcon size={12} data-id="element-375" />,
        label: 'Unsubscribed'
      },
      bounced: {
        bg: 'bg-red-100',
        text: 'text-red-800',
        icon: <XCircleIcon size={12} data-id="element-376" />,
        label: 'Bounced'
      },
      pending: {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        icon: <MailIcon size={12} data-id="element-377" />,
        label: 'Pending'
      }
    };
    const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.pending;
    return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`} data-id="element-378">
        <span className="mr-1" data-id="element-379">{config.icon}</span>
        {config.label}
      </span>;
  };
  return <div className="space-y-6" data-id="element-380">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-381">
        <h2 className="text-2xl font-bold text-secondary-900" data-id="element-382">Recipients</h2>
        <div className="flex space-x-3 mt-3 sm:mt-0" data-id="element-383">
          <button className="btn btn-outline flex items-center" data-id="element-384">
            <DownloadIcon size={16} className="mr-1" data-id="element-385" />
            <span data-id="element-386">Export</span>
          </button>
          <button className="btn btn-outline flex items-center" data-id="element-387">
            <UploadIcon size={16} className="mr-1" data-id="element-388" />
            <span data-id="element-389">Import</span>
          </button>
          <button className="btn btn-primary flex items-center" data-id="element-390">
            <PlusIcon size={16} className="mr-1" data-id="element-391" />
            <span data-id="element-392">Add Recipient</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-393">
        {groups.map(group => <button key={group.id} onClick={() => setActiveTab(group.id)} className={`card transition-all ${activeTab === group.id ? 'ring-2 ring-primary-600 bg-primary-50' : 'hover:shadow-md'}`} data-id="element-394">
            <div className="flex items-center justify-between" data-id="element-395">
              <div data-id="element-396">
                <p className="text-sm text-secondary-600" data-id="element-397">{group.name}</p>
                <p className="text-2xl font-semibold text-secondary-900 mt-1" data-id="element-398">
                  {group.count.toLocaleString()}
                </p>
              </div>
              <UsersIcon size={24} className={activeTab === group.id ? 'text-primary-600' : 'text-secondary-400'} data-id="element-399" />
            </div>
          </button>)}
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-400">
        <div className="relative flex-1 max-w-md" data-id="element-401">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-402">
            <SearchIcon size={18} className="text-secondary-400" data-id="element-403" />
          </div>
          <input type="text" placeholder="Search recipients..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 input" data-id="element-404" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-405">
          <div className="flex items-center space-x-2" data-id="element-406">
            <FilterIcon size={16} className="text-secondary-500" data-id="element-407" />
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-secondary-300 rounded-md text-secondary-700 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500" data-id="element-408">
              <option value="all" data-id="element-409">All Status</option>
              <option value="subscribed" data-id="element-410">Subscribed</option>
              <option value="unsubscribed" data-id="element-411">Unsubscribed</option>
              <option value="bounced" data-id="element-412">Bounced</option>
              <option value="pending" data-id="element-413">Pending</option>
            </select>
          </div>
        </div>
      </div>
      <div className="table-container" data-id="element-414">
        <table className="table" data-id="element-415">
          <thead className="table-header" data-id="element-416">
            <tr data-id="element-417">
              <th className="table-header-cell" data-id="element-418">Name</th>
              <th className="table-header-cell" data-id="element-419">Email</th>
              <th className="table-header-cell" data-id="element-420">Status</th>
              <th className="table-header-cell" data-id="element-421">Group</th>
              <th className="table-header-cell" data-id="element-422">Joined Date</th>
              <th className="table-header-cell" data-id="element-423">Last Activity</th>
              <th className="table-header-cell" data-id="element-424">Engagement</th>
              <th className="table-header-cell" data-id="element-425">Actions</th>
            </tr>
          </thead>
          <tbody className="table-body" data-id="element-426">
            {filteredRecipients.map(recipient => <tr key={recipient.id} className="table-row" data-id="element-427">
                <td className="table-cell font-medium" data-id="element-428">{recipient.name}</td>
                <td className="table-cell" data-id="element-429">{recipient.email}</td>
                <td className="table-cell" data-id="element-430">
                  {getStatusBadge(recipient.status)}
                </td>
                <td className="table-cell" data-id="element-431">{recipient.group}</td>
                <td className="table-cell" data-id="element-432">{recipient.joinedDate}</td>
                <td className="table-cell" data-id="element-433">{recipient.lastActivity}</td>
                <td className="table-cell" data-id="element-434">
                  <div className="flex flex-col" data-id="element-435">
                    <span className="text-xs text-secondary-600" data-id="element-436">
                      {recipient.emailsOpened}/{recipient.emailsSent} opened
                    </span>
                    <div className="w-full bg-secondary-200 rounded-full h-1.5 mt-1" data-id="element-437">
                      <div className="bg-primary-600 h-1.5 rounded-full" style={{
                    width: `${recipient.emailsOpened / recipient.emailsSent * 100}%`
                  }} data-id="element-438"></div>
                    </div>
                  </div>
                </td>
                <td className="table-cell" data-id="element-439">
                  <div className="flex items-center space-x-2" data-id="element-440">
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Edit" data-id="element-441">
                      <EditIcon size={16} data-id="element-442" />
                    </button>
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="Delete" data-id="element-443">
                      <TrashIcon size={16} data-id="element-444" />
                    </button>
                    <button className="p-1 rounded-md text-secondary-500 hover:bg-secondary-100" title="More options" data-id="element-445">
                      <MoreHorizontalIcon size={16} data-id="element-446" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default Recipients;